export default "__VITE_ASSET__CKx_kROF__"